import { useState } from "react";
import toast from "react-hot-toast";
import { createCreditNote } from "../service";

const DetailsBox = ({ index, dispute, handleDisputeClick }) => {
    console.log("🚀 ~ DetailsBox ~ dispute:", dispute)
    const [loading, setLoading] = useState(false);

    const handleRefund = async (job_id) => {
        setLoading(true);
        try {
            const response = await createCreditNote(job_id);
            if (response.status === "Success") {
                // Assuming the response contains a message or data to show
                toast.success(response.message ||"Refund processed successfully!");
            } else {
                console.error("Failed to process refund:", response);
                toast.error(response.message || "Failed to process refund.");
            }
        } catch (error) {
            console.error("Error processing refund:", error);
            toast.error("Error processing refund.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={`card card-body ${index !== 0 && 'mt-3'}`} onClick={() => handleDisputeClick(dispute)}>
            <div className="row gx-4">
                <div className="col-auto">
                    <div className="position-relative">
                        <img 
                            src={dispute?.dispute_details?.images?.length > 0 ? dispute?.dispute_details.images[0].path : '/assets/img/empty_image.jpg'} alt="profile_image" 
                            className="border-radius-lg shadow-sm" 
                            style={{
                                maxWidth: '80px',
                                minWidth: '80px',
                                maxHeight: '80px',
                                minHeight: '80px',
                            }}
                        />
                    </div>
                </div>
                <div className="col-auto my-auto">
                    <div className="h-100">
                        <h5 className="mb-1">
                            {dispute?.dispute_details.type}
                        </h5>
                        <p className="mb-0 font-weight-normal text-sm">
                            {dispute?.id}
                        </p>
                    </div>
                </div>

                <div className="col-auto ms-auto">
                    {dispute?.dispute_is_resolved === 1 && (
                        <i 
                            className="material-icons opacity-10 text-success"
                        >check_circle</i>
                    )}

                    {loading ? (
                        <>Loading...</>
                    ) : (
                        <i 
                            className="material-icons opacity-10 pointer"
                            onClick={(e) => {
                                e.stopPropagation(); // prevent triggering handleDisputeClick
                                handleRefund(dispute?.dispute_job?.job_id);
                            }}
                        >refresh</i>
                    )}
                </div>
            </div>
        </div>
    )
};

export default DetailsBox;